import React, {useEffect, useState, useContext} from 'react';
import {GuardedRoute} from 'react-router-guards';
import {DataContext} from '../../utils/DataProvider';
import FarmsDetails from '../FarmsDetails/FarmsDetails';
import Livestock from '../Livestock/Livestock';
import Team from '../Team/Team';
import Customers from '../Customer/Customer';
import Harvests from '../Harvests/Harvests';
import Machine from '../Machine/Machine';
import Stock from '../Stock/Stock';
import Climates from '../Climates/Climates';
import Financials from '../Financials/Financials';
import HarvestsDetails from '../HarvestsDetails/HarvestsDetails';
import Farm from '../Farm/Farm';
import Dashboards from '../Dashboards';
import Settings from '../Settings/Settings';
import Exportation from '../Exportation';
import Processing from '../Processing';
import Technical from '../Users/Technical/Technical';
import Admin from '../Users/Admin/Admin';
import Checklist from '../Checklist/Checklist';
import Herd from '../Diagnosis/Herd/Herd';
import Administrative from '../Diagnosis/Administrative/Administrative';
import EnvironmentCategories from '../Categories/EnvironmentCategories';
import Benchmark from '../Benchmark';
import SyntheticWithData from '../Checklist/Synthetic/SyntheticWithData';
import Communication from '../Communication';
import Faq from '../Communication/QuestionFaq/faq';
import QuestionFaq from '../Communication/QuestionFaq/questionFaq';
import Import from '../Import';
import './style.scss';
import {fetchDash} from '../../services/entries';
import DashDataGrid from '../../components/DataGrid/DashDataGrid';
import financialsColumns from '../Financials/FinancialsDatagridModelDash';
import {fetchFinancials} from '../../services/financials';
import {maskInput} from '../../utils/utils';
import {MASKS} from '../../utils/constants';


const Entries = ({match}) => {
  const {state, stateFetchParams, filterParams, stateFetchParamsCustom} = useContext(DataContext);
  const [data, setData] = useState(null);
  const [dat, setDat] = useState(null);
  const [da, setDa] = useState(null);
  const [totalItems, setTotalItems] = useState(0);
  const pathname = window.location.pathname.replace(/\/+$/, '');
  const lastSegment = pathname.split('/').pop();
  const showChart = lastSegment === 'diagnostico' || lastSegment === 'lancamentos';

  useEffect(() => {
    if (!showChart) {
      setData(null);
      return;
    }
    const getContents = async () => {
      try {
        const res = await fetchFinancials({
          type: 'RECEITAS',
          agrupe: true,
          ...stateFetchParams,
          ...filterParams,
        });

        setTotalItems(res.data.size);

        setTotalItems(res.data.size);
        const formattedData = res.data.resultList.map(item => ({
          ...item,
          value: item.value,
          valueFormatted: maskInput({ value: item.value, type: MASKS.MONEY })
        }));


      setDat(formattedData);
        //setDat(res.data.resultList);
      } catch (error) {
        console.error(error);
      }
    };
    getContents();
    // eslint-disable-next-line
  }, [stateFetchParams]);

  useEffect(() => {
    if (!showChart) {
      setData(null);
      return;
    }
    const getContents = async () => {
      try {
        const res = await fetchFinancials({
          type: 'DESPESAS',
          agrupe: true,
          ...stateFetchParams,
          ...filterParams,
        });

        setTotalItems(res.data.size);
        const formattedData = res.data.resultList.map(item => ({
          ...item,
          value: item.value,
          valueFormatted: maskInput({ value: item.value, type: MASKS.MONEY })
        }));


      setDa(formattedData);
        //setDa(res.data.resultList);
      } catch (error) {
        console.error(error);
      }
    };
    getContents();
    // eslint-disable-next-line
  }, [stateFetchParams]);

  useEffect(() => {
    if (!showChart) {
      setData(null);
      return;
    }

    let isMounted = true;

    const fetchData = async () => {
      try {
          const response = await fetchDash(stateFetchParamsCustom.harvest_id, stateFetchParamsCustom.customer_id, stateFetchParamsCustom.farm_id);
       //   setData(response.data);
          if (isMounted) {
            setData(response.data);
          }

        } catch (error) {
            console.error('Erro ao buscar dashboard:', error);
            return null;
      }
    };
    fetchData();
  }, [stateFetchParamsCustom.harvest_id, stateFetchParamsCustom.customer_id, stateFetchParamsCustom.farm_id, showChart]);

  if (showChart && !data) return <p>Carregando...</p>;

  const pieColors = ['#28a745', '#dc3545', '#fd7e14', '#1B98E0', '#FFD700', '#FA8072', '#836FFF'];
  const rectStyles = pieColors.map((color) => ({
    backgroundColor: color,
    color: '#fff',
    padding: '35px 0',
    borderRadius: '10px',
    fontWeight: 'bold',
    minWidth: '250px',
    textAlign: 'center',
    fontSize: '16px',
    marginTop: '25px',
    height: '180px',
  }));

  return (
    <div className={`entries-content ${match.url.replace('/corte/' || '/leite/', '')}`}>
      <div className="control-pane" style={{height: '100%', overflow: 'auto'}}>
        <div className="control-section">
          <div className="col-md-12 p-0 h-100">
            {showChart && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '70px 0',
                }}>
                <div style={{display: 'flex', gap: '18px', marginBottom: '20px', flexWrap: 'wrap', justifyContent: 'center'}}>
                  <div style={rectStyles[0]}>
                    <u className="fal fa-chart-line" style={{marginRight: '5px', fontSize: '55px'}} /> <br />
                    <br />
                    GMD Global <br /> {data.globalCapacityHa.toFixed(3)}
                  </div>
                  <div style={rectStyles[1]}>
                    <u className="fal fa-thin fa-cow" style={{marginRight: '5px', fontSize: '55px'}} /> <br />
                    <br />
                    Lotação Global UA/HA <br /> {data.productionHAKgPV.toFixed(2)}
                  </div>
                  <div style={rectStyles[3]}>
                    <u className="far fa-chart-bar" style={{marginRight: '5px', fontSize: '55px'}} /> <br />
                    <br />
                    Valor médio de venda (@) <br /> R$ {data.averageSaleValueStock.toFixed(2)}
                  </div>
                  <div style={rectStyles[2]}>
                    <u className="fal fa-money-bill" style={{marginRight: '5px', fontSize: '55px'}} /> <br />
                    <br />
                    Desebolso/cab/mes <br /> R$ {data.cabMes.toFixed(2)}
                  </div>
                </div>
                <div style={{display: 'flex', gap: '18px', marginBottom: '20px', flexWrap: 'wrap', justifyContent: 'center'}}>
                  <div style={rectStyles[4]}>
                    <u className="fal fa-money-bill" style={{marginRight: '5px', fontSize: '55px'}} /> <br />
                    <br />
                    Desembolso cab/mes nutrição <br /> R$ {data.trition.toFixed(2)}
                  </div>
                  <div style={rectStyles[5]}>
                    <u className="fal fa-money-bill" style={{marginRight: '5px', fontSize: '55px'}} /> <br />
                    <br />
                    Desembolso cab/mes pastagem <br /> R$ {data.pature.toFixed(2)}
                  </div>
                  <div style={rectStyles[6]}>
                    <u className="fal fa-money-bill" style={{marginRight: '5px', fontSize: '55px'}} /> <br />
                    <br />
                    Desembolso/100g de GMD <br /> R$ {data.disbursement.toFixed(2)}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "20px", width: "100%", justifyContent: "center", }}>
                  {dat && (
                    <div style={{ flex: 0.30, maxWidth: '50%', }}>
                      <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                        Receita
                      </div>
                      <DashDataGrid
                        header={financialsColumns({costCenter: match.params.slug}, {user: state.user}, state)}
                        data={dat}
                        keyProp="key"
                        keyValueProp="valueKey"
                        titleProp="name"
                        totalItems={totalItems}
                        editable={false}
                        showToolbar={false}
                        accumulators={{
                          'Total geral': {
                            columns: ['valueFormatted'],
                            itemOperation: (acc, line, key) => {
                              //return (acc += line[key]);
                              return acc + (line.value || 0);
                            },
                            resultOperation: (acc) => {
                              return maskInput({value: acc, type: MASKS.MONEY});
                            },
                          },
                        }}
                        />
                    </div>
                  )}

                  {da && (
                    <div style={{ flex: 0.30, maxWidth: '50%' }}>
                      <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                        Despesas
                      </div>
                      <DashDataGrid
                        header={financialsColumns({costCenter: match.params.slug}, {user: state.user}, state)}
                        data={da}
                        keyProp="key"
                        keyValueProp="valueKey"
                        titleProp="name"
                        totalItems={totalItems}
                        editable={false}
                        showToolbar={false}
                        accumulators={{
                          'Total geral': {
                            columns: ['valueFormatted'],
                            itemOperation: (acc, line, key) => {
                              //return (acc += line[key]);
                              return acc + (line.value || 0);
                            },
                            resultOperation: (acc) => {
                              return maskInput({value: acc, type: MASKS.MONEY});
                            },
                          },
                        }}
                      />
                    </div>  
                  )}
                </div>
              </div>
            )}

            {/* Rotas protegidas */}
            <GuardedRoute path={`${match.url}/administrativo`} meta={{moduleName: 'Administrativo'}} component={Administrative} />
            <GuardedRoute path={`${match.url}/rebanho`} meta={{moduleName: 'Rebanho'}} component={Herd} />
            <GuardedRoute path={`${match.url}/caracteriza-fazenda`} meta={{moduleName: 'Caracteriza fazenda'}} component={FarmsDetails} />
            <GuardedRoute path={`${match.url}/detalhes-fazenda`} meta={{moduleName: 'Caracteriza fazenda'}} component={FarmsDetails} />
            <GuardedRoute path={`${match.url}/equipe`} meta={{moduleName: 'Equipe'}} component={Team} />
            <GuardedRoute path={`${match.url}/pecuaria`} meta={{moduleName: 'Pecuária'}} component={Livestock} />
            <GuardedRoute path={`${match.url}/financeiro`} meta={{moduleName: 'Financeiro'}} component={Financials} />
            <GuardedRoute path={`${match.url}/maquinas`} meta={{moduleName: 'Máquinas'}} component={Machine} />
            <GuardedRoute path={`${match.url}/clientes`} meta={{moduleName: 'Clientes'}} component={Customers} />
            <GuardedRoute path={`${match.url}/safra`} meta={{moduleName: 'Safra'}} component={Harvests} />
            <GuardedRoute path={`${match.url}/caracteriza-safra`} meta={{moduleName: 'Caracteriza Safra'}} component={HarvestsDetails} />
            <GuardedRoute path={`${match.url}/tecnico`} meta={{moduleName: 'Técnicos'}} component={Technical} />
            <GuardedRoute path={`${match.url}/admin`} meta={{moduleName: 'Administradores'}} component={Admin} />
            <GuardedRoute path={`${match.url}/estoque`} meta={{moduleName: 'Estoque'}} component={Stock} />
            <GuardedRoute path={`${match.url}/fazenda`} meta={{moduleName: 'Fazenda'}} component={Farm} />
            <GuardedRoute path={`${match.url}/categorias`} meta={{moduleName: 'Categorias'}} component={EnvironmentCategories} />
            <GuardedRoute path={`${match.url}/clima`} meta={{moduleName: 'Clima'}} component={Climates} />
            <GuardedRoute path={`${match.url}/confira-lancamentos`} meta={{moduleName: 'Lançamentos'}} component={SyntheticWithData} />

            <GuardedRoute path="/corte/dashboards" meta={{moduleName: 'Dashboards'}} component={Dashboards} />
            <GuardedRoute path="/corte/configuracao" meta={{moduleName: 'Configurações'}} component={Settings} />
            <GuardedRoute path="/corte/checklist" meta={{moduleName: 'Checklist'}} component={Checklist} />
            <GuardedRoute path="/corte/exportacao" meta={{moduleName: 'Exportação'}} component={Exportation} />
            <GuardedRoute path="/corte/import" meta={{moduleName: 'Importação'}} component={Import} />
            <GuardedRoute path="/corte/processamento" meta={{moduleName: 'Processamento'}} component={Processing} />
            <GuardedRoute path="/corte/benchmark" meta={{moduleName: 'Benchmark'}} component={Benchmark} />
            <GuardedRoute path="/corte/comunicacao" meta={{moduleName: 'Comunicação'}} component={Communication} />
            <GuardedRoute path="/corte/faq" meta={{moduleName: 'Faq'}} component={Faq} />
            <GuardedRoute path="/corte/faq-categoria/:id" meta={{moduleName: 'Faq'}} component={QuestionFaq} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Entries;
